import { cx } from '../lib/cx.ts';

type SpinnerProps = {
  /** Announced to screen readers. Give it something specific where you can. */
  label?: string;
  size?: 'sm' | 'md';
  className?: string;
};

export function Spinner({ label = 'Loading', size = 'md', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cx('inline-flex items-center justify-center', className)}
    >
      <svg
        className={cx('animate-spin', size === 'sm' ? 'size-4' : 'size-6')}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeOpacity="0.25"
          strokeWidth="2.5"
        />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}
